import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'help-chat',
  templateUrl: './help-chat.component.html',
  styleUrls: ['../help.content.css']
})
export class HelpChatComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
